import React from "react";

const JQuery_Study_Plan = () => {
  return (
    <div>
      <h1>JQuery_Study_Plan</h1>
      <p>Placeholder component for: "JQuery_Study_Plan"</p>
    </div>
  );
};

export default JQuery_Study_Plan;
